/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseProfileData } from '../../models/api-response-profile-data';
import { ProfileData } from '../../models/profile-data';

export interface UpdateCompanyWaProfile$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  wabaPhoneId: string;
      body?: {
'profileData': ProfileData;
'media'?: Blob;
}
}

export function updateCompanyWaProfile(http: HttpClient, rootUrl: string, params: UpdateCompanyWaProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseProfileData>> {
  const rb = new RequestBuilder(rootUrl, updateCompanyWaProfile.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('wabaPhoneId', params.wabaPhoneId, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseProfileData>;
    })
  );
}

updateCompanyWaProfile.PATH = '/v1/api/ui/company/{wabaPhoneId}';
